export const fetchConectedAccounts = async (welletContext) => {
  try {
    const body = {
        BaseFilter:null
      };
    const response = await welletContext.apis.tickets.post('/api/invitation/ConectedAccounts', body);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const invitePostNetworkLevelSummary= async (welletContext) => {
  try {
    const response = await welletContext.apis.tickets.post('/api/invitation/GetNetworkLevelSummary');
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchTopNetworkUsers = async (welletContext) => {
  try {
    const response = await welletContext.apis.tickets.post('/api/invitation/GetTopNetworkUsers');
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};